import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import api from "core/interceptors/api";
import { disableBackNavigation } from "core/utils/storage";

function ServiceDropDown({ onSelectOption }) {
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState([]);
  const [selectedOption, setSelectedOption] = useState("AllServices");

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    onSelectOption(value);
  };

  const fetchServices = async () => {
    try {
      const res = await api.get("/services_register/fetch");
      console.log("Fetched services:", res.data); // Debugging
      setServices(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    disableBackNavigation();
    document.title = "Admin";
    fetchServices();
  }, []);

  return (
    <FormControl fullWidth margin="normal">
      <InputLabel>Select Service</InputLabel>
      <Select
        label="Select Service"
        name="service-select"
        value={selectedOption}
        onChange={handleChange}
        sx={{ height: "45px", width: "250px" }}
      >
        <MenuItem value="AllServices">All Services</MenuItem>
        {loading ? (
          <MenuItem disabled>Loading...</MenuItem>
        ) : (
          services.map((service) => (
            <MenuItem key={service.id} value={service.service_email}>
              {service.service_name}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
}

export default ServiceDropDown;
